<template>
    <v-dialog v-model="dialog"
              :overlay="false"
              scrollable
              v-resize="onResize"
              v-if="activeplayer"
              max-width="450"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                    color="awesome"
                    block
                    dark
                    v-on="on"
            >
                Profile Videos
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                {{activeplayer.info.firstname||'Player'}}'s Profile Videos
            </v-card-title>
            <v-card-text class="py-0">
                <v-row>
                    <v-col cols="12">
                        These videos will show up on your public profile page
                    </v-col>
                    <v-col cols="12" class="pa-0">
                        <v-card flat outlined v-for="(v, i ) in activeplayer.sport[sportcode]['profilevideos']"
                                :key="v.sortkey"
                                class="mb-2"
                        >
                            <v-card-title class="font-weight-light">
                                {{v.videotitle}}
                            </v-card-title>
                            <v-card-subtitle  class="font-weight-light">
                                {{v.videome}}
                            </v-card-subtitle>
                            <video style="width:100%;" preload="auto" class="videoplayer" transition="rotate"
                                   controls>
                                <source :poster="v.thumb" :src="v.url720p" type="video/mp4">
                            </video>
                            <v-card-actions>
                                <v-btn text small @click="removeVideoFromProfile(v.sortkey)">
                                    <v-icon>{{icons.checkoff}}</v-icon>
                                    remove
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="dialog=false"><v-icon>{{icons.close}}</v-icon> Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    components: {},
    name: "PlayerProfileVideos",
    data() {
      return {
        dialog: false
      }
    },
    mounted() {
    },
    computed: {
      ...mapState(['icons','sportcode','activeplayer'])
    },
    methods: {
      ...mapActions(['post']),
      onResize() {
        this.windowSize = {x: window.innerWidth, y: window.innerHeight}
        this.playerwidth = ((window.innerWidth - 32) > 640) ? 640 : (window.innerWidth - 32);
        this.playerheight = this.playerwidth * .609
      },
      async removeVideoFromProfile(sortkey) {
        //add video to player profile
        var em = this;
        let data = {
          partkey: this.activeplayer.partkey,
          playerurl: this.activeplayer.partkey,
          sport: this.sportcode,
          videoname: sortkey
        }
        let res = await this.post({path:'api/profilesv2/profilevideo',body:data})
        delete this.activeplayer.sport[this.sportcode].profilevideos[sortkey];
        this.dialog = false;
      },
    }
  }
</script>

<style scoped>

</style>